import React from "react"
import { Link } from 'react-router-dom'
import "../App.css"
import "./Artwork.css"

export default class ArtworkMini extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            artList: []
        }
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_PATH + "/file-uploads", {
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            },
        })
        .then(res => res.json())
        .then(
            result => {
                this.setState({
                    artList: result[0].filter(art => (
                        art.attributes.postID === this.props.postID
                    )).slice(0, 4)
                })
                console.log(this.state.artList)
            }
        )
    }

    render() {
        let renderArt
        if (this.state.artList.length != 0) {
            renderArt = this.state.artList.map(art => ( 
                <div>
                    <img alt='art for story' className="artMiniImg" src={"https://webdev.cse.buffalo.edu" + art.path}></img>
                </div>
            ))
        }
        else {
            renderArt = <p style={{ fontSize:"16px", color:"grey" }}>The gallery is empty! Be the first to upload! :)</p>
        }

        return (
            <div className="artMiniBox">
                <div className="artMiniTitle">Artwork</div>
                <div className="artMiniDisplay">{renderArt}</div>
                    <Link to={"/artwork/" + this.props.postID} style={{ textDecoration:"none", color:"white" }}>
                        <button className="artMiniButton">
                            View All
                        </button>
                    </Link>
            </div>
        )
    }
}